<template>
  <rounded-card
    :head-text="$t('login.choose_a_country_code')"
    :head-style="'margin-bottom: 0.5rem;'"
    :padding="true"
    :show-right-btn="true"
    @set-close-status="$emit('set-close-status')"
  >
    <div ref="countryCodeScroll" class="scroller ml-16">
      <div
        v-for="(item, index) in countryCodes"
        :key="item.code"
        class="flex justify-center mt-6 mb-6 text-sm"
        :class="{ active: index === activeIndex }"
        @click="activeIndex = index"
      >
        <div class="country relative">
          <img
            v-if="index === activeIndex"
            class="circle absolute"
            src="../../../assets/common/group-471.svg"
          />
          <div class="country-name">
            {{ item.name }}
          </div>
        </div>
        <div class="code w-20">{{ item.value }}</div>
      </div>
    </div>
    <div class="w-full">
      <div class="mask h-2"></div>
      <div class="flex justify-center pt-2 pb-6 bg-white">
        <c-button @click="setCountryCode">{{ $t('login.continue') }}</c-button>
      </div>
      <div class="flex justify-center">
        <span class="text-blue-gradient country-code-not-found">{{
          $t('login.country_code_not_found')
        }}</span>
      </div>
      <div class="flex justify-center pt-2 pb-6 bg-white">
        <c-button secondary @click="$emit('use-email')">
          <span class="pl-4 pr-4">{{ $t('login.try_use_email') }}</span>
        </c-button>
      </div>
    </div>
  </rounded-card>
</template>

<script>
import Storage from '@/modules/storage';
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';
import countryCodes from '@/lib/SupportedCountryCodes';

export default {
  components: {
    RoundedCard,
    CButton,
  },
  props: {
    countryCode: Object,
    showCountryCode: Boolean,
  },
  data() {
    return {
      activeIndex: 0,
      searchData: '',
      position: 0,
      countryCodes,
    };
  },
  mounted() {
    this.$refs.countryCodeScroll.addEventListener('scroll', this.onScroll);
    this.onScroll({ currentTarget: this.$refs.countryCodeScroll });
    // scroll to target country code
    this.activeIndex = this.countryCodes.findIndex(item => item.name === this.countryCode.name);
    if (this.activeIndex === -1) {
      Storage.removeCountryCode();
      this.activeIndex = 0;
    }
    this.scrollTo(this.activeIndex);
  },
  beforeDestroy() {
    this.$refs.countryCodeScroll.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    scrollTo(index) {
      setTimeout(() => {
        const scroller = this.$refs.countryCodeScroll;
        const y =
          scroller.children[index].offsetTop - scroller.offsetTop - scroller.clientHeight / 2;
        scroller.scrollTo(0, y, true);
      }, 100);
    },
    setCountryCode() {
      const code = this.countryCodes[this.activeIndex];
      if (code) {
        Storage.setCountryCode(code);
        this.$emit('update:country-code', code);
      }
      this.$emit('set-close-status');
    },
    onScroll(e) {
      const el = e.currentTarget;
      const isScrollable = el.scrollHeight > el.clientHeight;

      // GUARD: If element is not scrollable, remove all classes
      if (!isScrollable) {
        el.classList.remove('is-bottom-overflowing', 'is-top-overflowing');
        return;
      }

      const isScrolledToBottom = el.scrollHeight < el.clientHeight + el.scrollTop + 1;
      const isScrolledToTop = isScrolledToBottom ? false : el.scrollTop <= 0;
      el.classList.toggle('is-bottom-overflowing', !isScrolledToBottom);
      el.classList.toggle('is-top-overflowing', !isScrolledToTop);
    },
  },
};
</script>

<style lang="scss" scoped>
.account-input {
  width: 309px;
  height: 45px;
  background-image: url('../../../assets/common/rectangle-1334.svg');

  input {
    background: none;
  }
}

.img-wrapper {
  min-width: 4rem;
}

.scroller {
  overflow-y: auto;
  scroll-behavior: smooth;
  width: 100%;

  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black var(--top-mask-size, 0),
    black calc(100% - var(--bottom-mask-size, 0)),
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black var(--top-mask-size, 0),
    black calc(100% - var(--bottom-mask-size, 0)),
    transparent 100%
  );
  --top-mask-size: 0px;
  --bottom-mask-size: 0px;
}

.scroller::-webkit-scrollbar {
  display: none;
}

.scroller.is-top-overflowing {
  --top-mask-size: 96px !important;
}

.scroller.is-bottom-overflowing {
  --bottom-mask-size: 96px !important;
}

.country-name {
  width: 10rem;
  white-space: nowrap;
  overflow: visible;
}

.active {
  .country,
  .code {
    background: var(--brand-gradient-vertical);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.circle {
  top: 3px;
  left: -24px;
}

.mask {
  background-color: rgba(255, 255, 255, 0.6);
}

.country-code-not-found {
  font-size: 12px;
}
</style>
